import ExclamationIcon from 'assets/icons/exclamation-triangle.svg?component'
import Button from 'components/UI/Buttons/Button'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import Wrapper from 'components/UI/Wrapper'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

const ClientErrorPage = ({ resetErrorBoundary }: { resetErrorBoundary?: () => void }) => {
  const goToMainPage = () => {
    resetErrorBoundary?.()
  }

  const { t } = useTranslation()

  return (
    <Wrapper twStyle={tw`h-screen flex flex-col justify-center items-center -translate-y-20 pt-7 sm:pt-0 p-5`}>
      <div tw='rounded-[100px] w-[96px] h-[96px] bg-grey-middle flex items-center justify-center '>
        <ExclamationIcon />
      </div>
      <Heading variant='title1' twStyle={tw`mt-4 text-center`}>
        {t('error-1')}
      </Heading>
      <Typography twStyle={tw`mt-4 text-grey-dark text-center`}>{t('error-2')}</Typography>
      <Button
        twStyle={tw`border-[1px] border-grey-middle rounded-[20px] mt-[40px] max-w-[470px]`}
        onClick={goToMainPage}
      >
        <Typography>Повторить</Typography>
      </Button>
    </Wrapper>
  )
}
export default ClientErrorPage
